
import { Navigate } from "react-router-dom";

/**
 * Learn component - Redirects to the main learn dashboard
 * This maintains backward compatibility while using the new route structure
 */
const Learn = () => {
  return <Navigate to="/learn/dashboard" replace />;
};

export default Learn;
